import { observable } from "@legendapp/state";

// ISO date strings ("YYYY-MM-DD"), not Date instances — LegendState stores
// should hold only serializable data (see the code-conventions rule). Date
// objects are constructed at the point of use (dateRangePresets.ts's
// parseISODate) rather than carried in the store itself.
export interface DateRange {
  start: string | null;
  end: string | null;
}

export type DatePreset = "day" | "week" | "month" | "custom";

interface FilterState {
  dateRange: DateRange;
  datePreset: DatePreset;
  // What the active preset actually resolved to once clamped to the selected
  // campaigns' window — written by the page that resolves it, read by the
  // header so the label always matches the data on screen.
  resolvedDateRange: DateRange;
  agency: number[];
  advertiser: number[];
  campaign: number[];
  strategy: string | null;
  creative: string | null;
}

const defaultValues: FilterState = {
  dateRange: { start: null, end: null },
  datePreset: "week",
  resolvedDateRange: { start: null, end: null },
  agency: [],
  advertiser: [],
  campaign: [],
  strategy: null,
  creative: null,
};

export const FilterStore$ = observable(defaultValues);
